import React, { useEffect, useState, useRef } from 'react';
import { ContentContainer, SectionPage, Row, Col, ComponentLoader, Button, Field, Select, Heading, FormHeader, Callout, ErrorSummary } from '@snsw-gel/react';
import { history } from '@starterapp/shared-services/history';
import { getLinkedCard, deleteCancel } from '../../../services/api-services';
import { dataLayer } from '../../../services/gtm-dataLayer';
import styles from './CancelCard.module.scss'

const CancelCardPage = () => {
    const [showSpinner, setShowSpinner] = useState(false);
    const [cardDetails, setCardDetails] = useState({});
    const [reason, setReason] = useState('');
    const [hasError, setHasError] = useState(false);
    const errorSummaryRef = useRef(null);

    useEffect(() => {
        if (errorSummaryRef.current) {
            errorSummaryRef.current.focus();
        }
    }, [hasError]);


    useEffect(() => {
        setShowSpinner(true);
        const currentUrl = window.location.href;
        const pageName = window.location.href.split('/').pop();
        dataLayer(currentUrl, pageName);

        getLinkedCard(['type']).then(response => {
            setCardDetails(response);
            setShowSpinner(false);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSubmitCancel = () => async _ => {
        setHasError(false)
        if (reason === '') {
            setHasError(true)
            return;
        }

        setShowSpinner(true);

        let response;
        try {
            response = await deleteCancel(reason);
        } catch (ex) { }

        setShowSpinner(false);

        if (!response._httpStatus || response._httpStatus === 200) {
            sessionStorage.setItem('ConfirmationResponse', 'cancel');
            sessionStorage.setItem('CardTypeText', cardDetails.cardType);
            history.push('/changeDetailsConfirmation');
            window.dispatchEvent(new PopStateEvent('popstate'));
        } else {
            history.push('/applicationError');
            window.dispatchEvent(new PopStateEvent('popstate'));
        }
    };

    return (
        <>
            <FormHeader
                label={'Cancel a NSW Seniors Card or NSW Senior Savers Card'}
                title={`Cancel your ${cardDetails.cardType}`}
            />
            <ContentContainer className={styles['content-container']}>
                <SectionPage>
                    <Row>
                        <Col span={6}>
                            {hasError &&
                                <div className={styles['error-margin']}>
                                    <ErrorSummary ref={errorSummaryRef}
                                        errors={[{ id: 'reason', text: 'Select an option to continue.' }]} />
                                </div>}
                            <Field
                                id='reason'
                                label='Why are you cancelling your card? (required)'
                                errorMessage='Select an option to continue.'
                                hasError={hasError}
                                aria-label='required'
                                className={`${styles['form-input']} ${hasError ? styles['has-error'] : ''}`}
                            >

                                <Select
                                    options={[
                                        { value: 'nameChange', text: 'Name Change' },
                                        { value: 'deceased', text: 'Deceased' },
                                        { value: 'moved', text: 'Interstate/Overseas Move' },
                                        { value: 'ineligible', text: 'No longer eligible' },
                                        { value: 'other', text: 'Other' }
                                    ]}
                                    onChange={(event) => { setReason(event.target.value); }}
                                    value={reason}
                                />
                            </Field>
                        </Col>
                    </Row>

                    <Row>
                        <Col span={6}>
                            <Callout
                                 headingElement="h5"
                                className={styles['support-section']}
                                title='Why we need your reason for cancelling'>
                                <p> It will help the Department of Communities and Justice, who manages the NSW Seniors Card Program, to evaluate and report on the program.</p>
                            </Callout>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8}>
                            <Heading level={2} >
                                What happens next?</Heading>
                            <p>
                                If you cancel your card, we will:
                                <ul>
                                    <li>disable your card</li>
                                    <li>remove this service from your account</li>
                                    <li>cancel your Gold Senior/Pensioner Opal card, if you have one</li>
                                    <li>cancel all communications about this service (this may take up to 6 weeks).</li>
                                </ul>
                            </p>
                        </Col>
                    </Row>

                </SectionPage>
                <Row>
                    <Col span={6}>
                        <Button
                            className={styles['cancel-button']}
                            variant='primary'
                            aria-label='Cancel my card'
                            onClick={onSubmitCancel()}>
                            Cancel card
                        </Button>
                        <Button
                            className={styles['uncancel-button']}
                            variant='secondary'
                            aria-label='Do not cancel card'
                            onClick={() => window.location.href = process.env.REACT_APP_SENIORS_DASHBOARD_URL}>
                            Do not cancel card
                        </Button>
                    </Col>
                </Row>
            </ContentContainer>
            {
                showSpinner && (<ComponentLoader fullPage />)
            }
        </>
    );
};

export default CancelCardPage;
